// Özet onay kuyruğu satırları — grid'den saf türetim (KpiApprovalQueue 600 satır sınırı için
// ayrıldı, 2026-10-08). Kuyruk yalnız YÜKLÜ yıllardan türer; aralık dışı onay bekleyenler için
// KpiQueueOutsideYears uyarısı var. Kırılım (spec §6.6): yalnız ham hücreler — üyeler ve ham üst
// girer; kırılımdan türetilmiş toplam ve grup/kategori satırı girmez.
import type { KpiResolvedCell, KpiResolvedGrid, KpiResolvedIndicator } from "@mahir/shared";
import { isBreakdownDerivedTotal } from "./kpi-grid-breakdown";

export interface QueueItem {
  indicator: KpiResolvedIndicator;
  entityId: string;
  entityName: string;
  year: number;
  cell: KpiResolvedCell;
  prev: KpiResolvedCell | undefined;
}

export function collectQueue(grid: KpiResolvedGrid): QueueItem[] {
  const out: QueueItem[] = [];
  const nameOf = new Map(grid.entities.map((e) => [e.id, e.name]));
  for (const ind of grid.indicators) {
    if (ind.nodeKind === "breakdown_group" || ind.nodeKind === "category") continue;
    // tembel: türetilmiş toplam denetimi yalnız kuyruk hücresi olan göstergede (O(n) tarama)
    let derivedTotal: boolean | undefined;
    for (const [entityId, byYear] of Object.entries(ind.cells)) {
      for (const [y, cell] of Object.entries(byYear)) {
        if (
          cell.workflowState === "submitted" ||
          cell.workflowState === "clarification" ||
          cell.workflowState === "client_approved"
        ) {
          derivedTotal ??= isBreakdownDerivedTotal(ind, grid.indicators);
          if (derivedTotal) continue;
          const year = Number(y);
          out.push({
            indicator: ind,
            entityId,
            entityName: nameOf.get(entityId) ?? "",
            year,
            cell,
            prev: byYear[year - 1],
          });
        }
      }
    }
  }
  return out.sort((a, b) => (b.cell.updatedAt ?? "").localeCompare(a.cell.updatedAt ?? ""));
}
